// Nav entry of Lessons (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({ id: 'lessons', path: '/lessons', icon: 'lessons', group: 'learn', phone: 'tab', order: 500, load: () => import('./Lessons') });
